import './Oursolution.css'
import { Group, Badge, Container, Title, Text, SimpleGrid, Card, Image } from '@mantine/core';
import APimgmt from '../Images/completed-task.png'
import Softwaredev from '../Images/countries.png';
import Saas from '../Images/service.png';
import Devops from '../Images//experts.png'

const mockdata = [
    {
        image: APimgmt,
        title: "30+ Local & Global Projects",
        // description: "CRM-led transformations, centralized customer data management, automated sales pipelines.",
    },
    {
        image: Softwaredev,
        title: "2+ Countries Served",
        // description: "Digital transformation initiatives, process automation, data integration solutions.",
    },
    {
        image: Devops,
        title: "100+ Technology Experts",
        // description: "CRM implementations like Dalko Logistics, process optimization, real-time tracking systems.",
    },
    {
        image: Saas,
        title: "3+ Years of Excellence",
        // description: "Monolith to microservices migration, application modernization, cloud workload migration.",
    },
    // {
    //     image: Webdev,
    //     title: "And other industries",
    //     description: "Full Stack (Java/.Net), Java Spring Boot, Salesforce, React, Angular development with modern frameworks.",
    // },

];










const OurImpact = () => {
    const features = mockdata.map((feature) => (
        <Card
            key={feature.title}
            shadow="md"
            radius="md"
            className="heading-card"
            padding="xl"
        >
            {/* <feature.icon size={50} stroke={2} color={theme.colors.blue[6]} /> */}
            <Image src={feature.image} alt={feature.title} h={50} w={50} />
            <Text fz="lg" fw={700} className={"heading-title"} mt="md" c={'white'}>
                {feature.title}
            </Text>
            <Text fz="sm" c="dimmed" mt="sm">
                {feature.description}
            </Text>
        </Card>
    ));
    return (
        <>
            <Group justify='center' mt={'xl'}>
                <Badge variant="outline" size="lg" p={'lg'} mt={'xl'} className='heading-pills'>
                    Our Impact
                </Badge>
            </Group>
            <Container mt={"xs"} size={"lg"} data-aos="fade-right">
                <Title ta={'center'} className='heading-as-text' size={'60'}>
                    Global Excellence
                </Title>
                <Group justify='center'>
                    <Text c={'white'} fw={'bold'} className='heading-description' mt={'md'}>
                        Transforming businesses worldwide with innovative solutions and measurable results.
                    </Text>
                </Group>


                <SimpleGrid cols={{ base: 1, md: 4 }} spacing="xl" mt={50}>
                    {features}
                </SimpleGrid>
            </Container>
        </>
    )
}

export default OurImpact;